<template>
  <div>
      <v-container>
            <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{ on, $attrs }">
                <label><span class="date-label">{{ lbl }}</span>
                <v-text-field
                    v-model="dateFormatted"
                    readonly
                    v-bind="$attrs"
                    hint="DD.MM.YYYY"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    @blur="date = parseDate(dateFormatted)"
                    v-on="on"
                ></v-text-field></label>
              </template>
              <v-date-picker
                  v-model="date"
                  no-title
                  @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
      </v-container>
  </div>
</template>

<script>
export default {
name: "DateField",
  props: {
    rcvdDate: {
      type: String
    },
    itmKey: {
      type:String
    },
    lbl: {
      type:String
    },
  },

data: function () {
  return {
    date: this.rcvdDate,
    menu1: false,
  }
},
  watch: {
    date (val) {
      console.log(val)
      this.$emit('datechanged', val)
      this.dateFormatted = this.formatDate(this.date)
    },
    itmKey: function(newVal) {
      console.log(`itmKey changed ${newVal}`)
      this.date= this.date=this.rcvdDate
    },

  },
  computed: {
    dateFormatted: {
      get: function () {
        return this.formatDate(this.date)
      },
      set: function (newDate) {
        console.log(newDate)
        this.date = this.parseDate(newDate)
      }
    },
  },

  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  },

}
</script>


<style scoped>
.date-label {
  font-size: 12px;
  color: grey;
  vert-align: top;
  horiz-align: left;
}
</style>
